module.exports = __webpack_public_path__ + "static/media/paper.7e00fdf5.svg";